import { ROUTE_NAME } from '@/const'

import { NavigationPreset } from './types'

import { 
  ArrowRightLeftIcon,
  ArrowUpDownIcon, 
  BanknoteArrowDownIcon, 
  BanknoteArrowUpIcon, 
  BriefcaseBusinessIcon, 
  ChartColumnIcon, 
  ChartNoAxesColumnIncreasingIcon, 
  ChartNoAxesCombinedIcon, 
  ChartNoAxesGanttIcon, 
  ChartPieIcon, 
  CircleDollarSign, 
  DatabaseIcon, 
  FolderOpenIcon, 
  GaugeIcon, 
  HandCoinsIcon, 
  LayersIcon, 
  LinkIcon, 
  ListFilterIcon, 
  ListTreeIcon, 
  NotebookTabsIcon, 
  TagIcon, 
  TagsIcon, 
  TrendingUpIcon, 
  WalletCardsIcon 
} from '@lucide/vue'

export const DASHBOARD_NAME = 'Dashboards'
export const CONNECTOR_NAME = 'Connectors'

export const PARENT_NAVIGATION: NavigationPreset[] = [
  {
    label: DASHBOARD_NAME,
    icon: ChartPieIcon,
    route: ROUTE_NAME.DASHBOARDS,
  },
  {
    label: 'Data',
    icon: DatabaseIcon,
  },
  {
    label: CONNECTOR_NAME,
    icon: LinkIcon,
  },
  {
    label: 'Analytics',
    icon: ChartNoAxesCombinedIcon,
  },
]

export const CHILDREN_NAVIGATION: Record<string, NavigationPreset[]> = {
  Data: [
    {
      label: 'Smart Transactions',
      icon: ArrowRightLeftIcon,
      route: ROUTE_NAME.TRANSACTIONS,
      additional: [ROUTE_NAME.TRANSACTIONS_ITEM],
    },
    {
      label: 'Assets',
      icon: ChartColumnIcon,
      route: ROUTE_NAME.ASSETS,
      additional: Object.entries(ROUTE_NAME)
        .filter(([key]) => key.startsWith('ASSETS_ITEM'))
        .map(([, value]) => value),
    },
    {
      label: 'Tags',
      icon: TagsIcon,
      route: ROUTE_NAME.TAGS,
      additional: [ROUTE_NAME.TAGS_ITEM],
    },
    {
      label: 'Income accounts',
      icon: BanknoteArrowUpIcon,
      route: ROUTE_NAME.INCOME_ACCOUNTS,
      additional: [ROUTE_NAME.INCOME_ACCOUNTS_ITEM],
    },
    {
      label: 'Expense accounts',
      icon: BanknoteArrowDownIcon,
      route: ROUTE_NAME.EXPENSE_ACCOUNTS,
      additional: [ROUTE_NAME.EXPENSE_ACCOUNTS_ITEM],
    },
    {
      label: 'Currencies',
      icon: CircleDollarSign,
      route: ROUTE_NAME.CURRENCIES,
      additional: [ROUTE_NAME.CURRENCIES_ITEM],
    },
    {
      label: 'Documents',
      icon: FolderOpenIcon,
      route: ROUTE_NAME.DOCUMENTS,
      additional: [ROUTE_NAME.DOCUMENTS_ITEM],
    },
    {
      label: 'Contacts',
      icon: NotebookTabsIcon,
      route: ROUTE_NAME.CONTACTS,
      additional: [ROUTE_NAME.CONTACTS_ITEM],
    },
  ],
  Connectors: [
    {
      label: 'Accounts',
      icon: WalletCardsIcon,
      route: ROUTE_NAME.LINKED_DATA,
      additional: [
        ROUTE_NAME.LINKED_DATA_ACCOUNT,
        ROUTE_NAME.LINKED_DATA_ACCOUNT_POSITIONS,
        ROUTE_NAME.LINKED_DATA_CONNECTOR,
      ],
    },
    {
      label: 'Transactions',
      icon: ArrowUpDownIcon,
      route: ROUTE_NAME.LINKED_DATA_TRANSACTIONS,
    },
    {
      label: 'Positions',
      icon: ChartNoAxesGanttIcon,
      route: ROUTE_NAME.LINKED_DATA_POSITIONS,
    },
    {
      label: 'Tax lots',
      icon: LayersIcon,
      route: ROUTE_NAME.LINKED_DATA_TAX_LOTS,
    },
    {
      label: 'Tagging rules',
      icon: TagIcon,
      route: ROUTE_NAME.LINKED_DATA_TAGGING_RULES,
    },
    {
      label: 'Mapping rules',
      icon: ListFilterIcon,
      route: ROUTE_NAME.LINKED_DATA_MAPPING_RULES,
    },
  ],
  Analytics: [
    {
      label: 'Value',
      icon: ChartNoAxesColumnIncreasingIcon,
      route: ROUTE_NAME.ANALYTICS_VALUE,
    },
    {
      label: 'Value Change',
      icon: TrendingUpIcon,
      route: ROUTE_NAME.ANALYTICS_VALUE_CHANGE,
    },
    {
      label: 'Income',
      icon: HandCoinsIcon,
      route: ROUTE_NAME.ANALYTICS_INCOME,
    },
    {
      label: 'Performance',
      icon: GaugeIcon,
      route: ROUTE_NAME.ANALYTICS_PERFORMANCE,
    },
    {
      label: 'Position',
      icon: BriefcaseBusinessIcon,
      route: ROUTE_NAME.ANALYTICS_POSITION,
    },
    {
      label: 'Tree',
      icon: ListTreeIcon,
      route: ROUTE_NAME.ANALYTICS_TREE,
    },
  ],
}
